import React from "react";
import { useState, useEffect, useCallback } from "react";
import catImage from "../images/homecat1.avif";
import dogImage from "../images/homeimg.avif";
import Navbar from "./Navbar.js";
import doghero2 from "../images/doghero2.avif";
import homecat from "../images/homecat2.avif";
import Footer from "./Footer.js";
import LaptopAndMobileNew from "../images/LaptopAndMobileNew.png";
import duke from "../images/duke.jpeg";
import { Link } from "react-router-dom";
import "font-awesome/css/font-awesome.min.css";
import { motion, AnimatePresence } from "framer-motion";
import { Helmet } from "react-helmet-async";

const Hero = () => {
  const textVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: { opacity: 1, y: 0, transition: { duration: 1 } },
  };

  const buttonVariants = {
    hover: { backgroundColor: "#BDA697", transition: { duration: 0.3 } },
  };

  const imageVariants = {
    hidden: { opacity: 0, x: -100 },
    visible: { opacity: 1, x: 0, transition: { duration: 1 } },
  };

  const cardHover = {
    hover: { scale: 1.05 },
  };

  const testimonials = [
    {
      name: "Stephanie",
      text: "This website provided excellent personalized information for my cavapoo. I had a question about his foot health, and got quick feedback after uploading a picture that helped me know what to do. I think this website will be helpful to pet owners everywhere!",
      image: "/images/testimonials/stephanie.jpeg",
    },
  ];

  const variants = {
    enter: (direction) => ({
      x: direction > 0 ? 60 : -60,
      opacity: 0,
    }),
    center: {
      x: 0,
      opacity: 1,
    },
    exit: (direction) => ({
      x: direction > 0 ? -60 : 60,
      opacity: 0,
    }),
  };
  const [[index, direction], setIndex] = useState([0, 0]);
  const [paused, setPaused] = useState(false);

  const paginate = useCallback((newDirection) => {
    setIndex(([prev]) => [
      (prev + newDirection + testimonials.length) % testimonials.length,
      newDirection,
    ]);
  }, []);

  useEffect(() => {
    if (paused) return;
    const timer = setInterval(() => paginate(1), 5000);
    return () => clearInterval(timer);
  }, [paused, paginate]);

  const current = testimonials[index];

  return (
    <section>
      <Helmet>
        <title>Furbabies.AI – AI Pet Health & Nutrition for Pet Lovers</title>
        <meta
          name="description"
          content="Assess your pet's health and customize their nutrition from home or on vacation. AI-powered care for pet lovers who treat their furbabies like family."
        />
      </Helmet>
      <section className="relative text-center mt-20 pt-16 pb-32">
        <Navbar />
        <div className="max-w-4xl mt-16 mx-auto px-4">
          <motion.h1
            variants={textVariants}
            initial="hidden"
            animate="visible"
            className=" lg:text-[90px] lg:leading-[100px] text-6xl font-bold text-gray-900 "
          >
            For Those Who
            <br /> Love Their Furbabies
          </motion.h1>
          <motion.p
            variants={textVariants}
            initial={{ opacity: 0 }}
            animate={{ opacity: 0.6 }}
            transition={{ delay: 0.2, duration: 0.8 }}
            className="mt-10 left-10  text-xl  lg:text-[18px] lg:leading-[28px] poppins-text  text-[#222222] "
          >
            Keep Your Furbaby Safe & Healthy by Using AI to
            <br /> Evaluate and Personalized their Health and Nutrition.
          </motion.p>
          <motion.button
            variants={buttonVariants}
            whileHover="hover"
            className="mt-10 text-xl px-12 py-4 bg-[#967d6c] lg:text-[20px] lg:leading-[26px] text-white font-bold rounded-full"
          >
            <Link to="/signup" className="text-white">
              Sign Up for Free
            </Link>
          </motion.button>
        </div>
        <motion.div
          className="absolute left-0 top-24 hidden xl:block"
          variants={imageVariants}
          initial="hidden"
          animate="visible"
        >
          <img
            src={catImage}
            alt="Cat"
            className="h-[36rem] mx-auto "
            loading="eager"
          />
          <div className="relative left-60 bottom-40 transform -translate-x-1/2 hidden lg:block">
            <div className="text-6xl  text-[#bda697] animate-paw-left-right">
              <i className="fa fa-paw"></i>
            </div>
          </div>
          <div className="relative bottom-96 right-12  transform translate-x-1/2 hidden lg:block">
            <div className="text-4xl text-[#bda697] animate-paw-right-left">
              <i className="fa fa-paw"></i>
            </div>
          </div>
        </motion.div>
        <motion.div
          className="absolute right-0 top-44 hidden bg-transparent xl:block"
          variants={{
            ...imageVariants,
            hidden: { opacity: 0, x: 100 },
          }}
          initial="hidden"
          animate="visible"
        >
          <img
            src={dogImage}
            alt="Dog"
            className="h-[36rem]  mx-auto"
            loading="eager"
          />
          <div className="relative bottom-32 left-16 transform -translate-x-1/2 hidden lg:block">
            <div className="text-4xl text-[#bda697] animate-paw-right-left">
              <i className="fa fa-paw"></i>
            </div>
          </div>
          <div className="absolute right-32 bottom-4 transform translate-x-1/2 hidden lg:block">
            <div className="text-6xl text-[#bda697] animate-paw-left-right">
              <i className="fa fa-paw"></i>
            </div>
          </div>
        </motion.div>
      </section>

      <section
        id="services"
        className="py-12 sm:py-16 lg:py-24 my-16 lg:my-32 bg-[#e8e1da]"
      >
        <h2 className="text-5xl  lg:text-[60px] lg:leading-[70px] font-bold text-gray-900 text-center mb-8 sm:mb-10">
          Furbabies.AI Features
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 px-4 max-w-7xl mx-auto">
          {[
            {
              title: "Pet Health - AI-Optimized",
              description:
                "Upload pics & videos of your furbaby to assess their safety and health at home or anywhere in the world.",
              icon: "/images/ai-vet.svg",
            },
            {
              title: "Pet Nutrition - AI-Informed",
              description:
                "Upload pics of food & ingredients to assess your furbaby’s nutrition and get recipes to make their meals.",
              icon: "/images/FoodBowlBrown.svg",
            },
            {
              title: "FurBot - AI Companion Pet Care",
              description:
                "Your 24/7 pet care companion to answer all of your questions with instant answers.",
              icon: "/images/FurbotFilled.svg",
            },
          ].map((service, index) => (
            <motion.div
              key={index}
              className="p-6 bg-white rounded-lg flex items-start transition-all min-h-[200px] shadow-sm"
              whileHover="hover"
              variants={cardHover}
            >
              <div className="w-16 h-16 flex-shrink-0">
                <img
                  src={service.icon}
                  alt={service.title}
                  className="w-14 h-14 transition-all duration-300"
                  loading="lazy"
                />
              </div>

              <div className="ml-4 flex flex-col">
                <h3 className="text-[20px] leading-[26px] text-[#222222] font-bold mb-1">
                  {service.title}
                </h3>
                <p className="text-[14px] opacity-60 sm:text-base poppins-text text-[#222222]">
                  {service.description}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </section>

      <div className="bg-[#ffffff] pt-10 px-6 md:px-10">
        <div className="grid grid-cols-1 md:grid-cols-2 items-center gap-8">
          <motion.div
            className="text-left xl:p-24"
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 1 }}
          >
            <motion.h1
              variants={textVariants}
              initial="hidden"
              animate="visible"
              className="lg:text-[60px] lg:leading-[70px] text-5xl font-bold text-black"
            >
              Why Pet Lovers
              <br />
              Use Furbabies.AI?
            </motion.h1>
            <motion.p
              variants={textVariants}
              initial={{ opacity: 0 }}
              animate={{ opacity: 0.6 }}
              transition={{ delay: 0.2, duration: 1 }}
              className="mt-8  text-xl lg:text-[18px] lg:leading-[28px]  poppins-text text-gray-600"
            >
              For those who love your furbabies, you know who you are. You are
              not just a Pet Owner, but a Pet Lover. Your furbabies are family.
              Your furbabies get the best food you can buy. Your furbabies have
              their own toys. Your furbabies are worth a few dollars a month to
              use Furbabies.AI to assess their health and safety from the
              comfort of your homes or while you are on vacation right on your
              mobile phone or computer. Also, Pet Lovers love the ability to
              customize your furbabies’ nutrition to extend and improve the
              quality of life for their precious companions.
            </motion.p>
          </motion.div>
          <motion.div
            className="flex justify-center"
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 1.2 }}
          >
            <div className="relative">
              <div className="hidden xl:block absolute top-28 left-0">
                <div className="text-5xl text-[#bda697] animate-paw-left-right">
                  <i className="fa fa-paw"></i>
                </div>
              </div>
              <div className="hidden xl:block absolute top-60 -right-14 ">
                <div className="text-4xl text-[#bda697] animate-paw-right-left">
                  <i className="fa fa-paw"></i>
                </div>
              </div>

              <img
                src={homecat}
                alt="Cat"
                className="rounded-xl w-full max-w-sm md:max-w-lg"
                loading="lazy"
              />
            </div>
          </motion.div>
        </div>
      </div>

      {/* ══ DUKE SECTION ══ */}
      <section className="py-24  bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
            {/* Left — Duke's image */}
            <motion.div
              className="flex justify-center"
              initial={{ opacity: 0, x: -50 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 1 }}
            >
              <div className="relative">
                {/* Decorative ring */}
                <div className="absolute inset-0 rounded-full border-4 border-[#bda697] scale-110 opacity-30" />
                <img
                  src={duke}
                  alt="Duke, Chief Happiness Officer"
                  className="w-90 h-90 md:w-[28rem] md:h-[28rem] rounded-full object-cover shadow-2xl ring-8 ring-white"
                  loading="lazy"
                />
                {/* Badge */}
                <div className="absolute -bottom-4 left-1/2 -translate-x-1/2 bg-[#967d6c] text-white text-sm font-bold px-5 py-2 rounded-full shadow-lg whitespace-nowrap">
                  Chief Happiness Officer
                </div>
                {/* Paw accents */}
                <div className="hidden md:block absolute -top-6 -right-6 text-4xl text-[#bda697] animate-paw-right-left select-none">
                  <i className="fa fa-paw" />
                </div>
                <div className="hidden md:block absolute -bottom-10 -left-8 text-3xl text-[#bda697] animate-paw-left-right select-none">
                  <i className="fa fa-paw" />
                </div>
              </div>
            </motion.div>

            {/* Right — Copy */}
            <motion.div
              className="text-left"
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 1, delay: 0.2 }}
            >
              <h2 className="lg:text-[60px] lg:leading-[70px] text-5xl font-bold text-gray-900 mb-6">
                Duke, Our Chief
                <br />
                <span className="text-[#967d6c]">Happiness Officer</span>
              </h2>

              <p className="text-xl lg:text-[18px] lg:leading-[28px] poppins-text text-gray-600 mb-4">
                Every great company needs a Chief Happiness Officer — and Duke
                takes his role very seriously. As the founding furbaby behind
                Furbabies.AI, Duke is the heart and inspiration of everything we
                do.
              </p>

              <p className="text-xl lg:text-[18px] lg:leading-[28px] poppins-text text-gray-600">
                His daily duties include quality-testing belly rubs, supervising
                nap schedules, and reminding the team why every furbaby deserves
                the very best care. Duke proves that when you love your pet like
                family, great things happen.
              </p>

              {/* Fun stats */}
              <div className="flex gap-8 mt-8">
                {[
                  { stat: "100%", label: "Good Boy" },
                  { stat: "24/7", label: "On Duty" },
                  { stat: "∞", label: "Happiness Delivered" },
                ].map(({ stat, label }) => (
                  <div key={label} className="text-center">
                    <p className="text-3xl font-bold text-[#967d6c]">{stat}</p>
                    <p className="text-sm poppins-text text-gray-500 mt-1">
                      {label}
                    </p>
                  </div>
                ))}
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      <section className="py-24 bg-[#e8e1da] mt-10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6  lg:px-8">
          <motion.h2
            className="lg:text-[60px] lg:leading-[70px] text-5xl font-bold text-gray-900 text-center mb-2"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
          >
            The Care Your Furbaby Deserves
          </motion.h2>
          <motion.p
            variants={textVariants}
            initial={{ opacity: 0 }}
            animate={{ opacity: 0.6 }}
            transition={{ delay: 0.2, duration: 1 }}
            className="  text-xl lg:text-[18px] lg:leading-[28px] text-center poppins-text mb-10 "
          >
            Get feeback on your pet's health immediately
          </motion.p>

          <motion.div
            className="w-full px-4"
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 1 }}
          >
            <img
              src={LaptopAndMobileNew}
              alt="LaptopAndMobile"
              className="w-full max-w-[90%] sm:max-w-[80%] md:max-w-[80%] lg:max-w-[90%] h-auto mx-auto"
              loading="lazy"
            />
          </motion.div>
        </div>
      </section>

      {/* ══ SAMPLE ANALYSIS SECTION ══ */}
      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-16 items-start">
            {/* Left — copy */}
            <motion.div
              className="text-left"
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 1 }}
            >
              <p className="text-[#967d6c] font-semibold poppins-text text-sm uppercase tracking-widest mb-3">
                See It For Yourself
              </p>
              <h2 className="lg:text-[60px] lg:leading-[70px] text-5xl font-bold text-gray-900 mb-6">
                See What a
                <br />
                <span className="text-[#967d6c]">Furbabies.AI</span>
                <br />
                Report Looks Like
              </h2>
              <p className="text-xl lg:text-[18px] lg:leading-[28px] poppins-text text-gray-600 mb-4">
                Curious about what Furbabies.AI actually produces? Download our
                sample reports to see the kind of educational information our
                members receive when they upload a photo of their pet or a photo
                of food ingredients.
              </p>
              <p className="text-xl lg:text-[18px] lg:leading-[28px] poppins-text text-gray-600 mb-3">
                These are real AI-generated reports provided for informational
                and educational purposes — the same format every member sees.
              </p>
              <p className="text-sm poppins-text text-gray-400 mb-10">
                Reports are for general educational purposes only and do not
                constitute veterinary advice. Always consult a licensed
                veterinarian for your pet's health needs.
              </p>
            </motion.div>

            {/* Right — two cards */}
            <motion.div
              className="flex flex-col gap-6"
              initial={{ opacity: 0, x: 50 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 1, delay: 0.2 }}
            >
              {/* Card 1 — Photo Analysis */}
              <div className="relative w-full">
                <div className="absolute top-3 left-3 w-full h-full bg-[#bda697] opacity-20 rounded-2xl" />
                <div className="relative bg-white border border-[#e8ddd6] rounded-2xl shadow-xl overflow-hidden">
                  <div className="bg-[#967d6c] px-6 py-4 flex items-center gap-3">
                    <img
                      src="/images/ai-vet.svg"
                      alt="Pet Health"
                      className="w-6 h-6 filter invert"
                    />
                    <div>
                      <p className="text-white font-bold text-sm">
                        Pet Health Report
                      </p>
                      <p className="text-white/70 text-xs poppins-text">
                        Sample Photo Analysis
                      </p>
                    </div>
                    <span className="ml-auto bg-white/20 text-white text-xs poppins-text px-2 py-0.5 rounded-full">
                      Sample
                    </span>
                  </div>
                  <div className="px-6 py-4 space-y-2.5">
                    {[
                      "Visual Observations",
                      "Possible Health Considerations",
                      "Diagnostic Tests to Discuss With Your Vet",
                      "Potential Treatments to Discuss With Your Vet",
                      "Immediate Comfort Guidance",
                    ].map((label, i) => (
                      <div key={i} className="flex items-center gap-3">
                        <span className="w-2 h-2 rounded-full bg-[#967d6c] flex-shrink-0" />
                        <span className="text-sm poppins-text text-gray-700">
                          {label}
                        </span>
                      </div>
                    ))}
                    <div className="relative">
                      <div className="flex items-center gap-3 opacity-30">
                        <span className="w-2 h-2 rounded-full bg-[#967d6c] flex-shrink-0" />
                        <span className="text-sm poppins-text text-gray-700">
                          And more...
                        </span>
                      </div>
                      <div className="absolute inset-0 bg-gradient-to-b from-transparent to-white" />
                    </div>
                  </div>
                  <div className="px-6 pb-5">
                    <a
                      href="/samples/Furbabies_Sample_Photo_Analysis.pdf"
                      download="Furbabies_Sample_Photo_Analysis.pdf"
                      className="flex items-center justify-center gap-2 w-full bg-[#967d6c] hover:bg-[#bda697] transition-colors text-white font-semibold text-sm poppins-text py-3 rounded-xl"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="w-4 h-4"
                        fill="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6zm-1 7V3.5L18.5 9H13zM8 17v-2h8v2H8zm0-4v-2h8v2H8z" />
                      </svg>
                      Download Sample Health Report
                    </a>
                  </div>
                </div>
              </div>

              {/* Card 2 — Meal Plan */}
              <div className="relative w-full">
                <div className="absolute top-3 left-3 w-full h-full bg-[#bda697] opacity-20 rounded-2xl" />
                <div className="relative bg-white border border-[#e8ddd6] rounded-2xl shadow-xl overflow-hidden">
                  <div className="bg-[#bda697] px-6 py-4 flex items-center gap-3">
                    <img
                      src="/images/FoodBowlBrown.svg"
                      alt="Nutrition"
                      className="w-6 h-6 filter invert"
                    />
                    <div>
                      <p className="text-white font-bold text-sm">
                        Pet Nutrition Report
                      </p>
                      <p className="text-white/70 text-xs poppins-text">
                        Sample Meal Plan Analysis
                      </p>
                    </div>
                    <span className="ml-auto bg-white/20 text-white text-xs poppins-text px-2 py-0.5 rounded-full">
                      Sample
                    </span>
                  </div>
                  <div className="px-6 py-4 space-y-2.5">
                    {[
                      "Ingredient / Label Analysis",
                      "Safety Assessment",
                      "Nutritional Evaluation",
                      "Suitability Summary",
                      "Meal Recommendations",
                      "Healthy Home-Prepared Alternatives",
                    ].map((label, i) => (
                      <div key={i} className="flex items-center gap-3">
                        <span className="w-2 h-2 rounded-full bg-[#bda697] flex-shrink-0" />
                        <span className="text-sm poppins-text text-gray-700">
                          {label}
                        </span>
                      </div>
                    ))}
                    <div className="relative">
                      <div className="flex items-center gap-3 opacity-30">
                        <span className="w-2 h-2 rounded-full bg-[#bda697] flex-shrink-0" />
                        <span className="text-sm poppins-text text-gray-700">
                          And more...
                        </span>
                      </div>
                      <div className="absolute inset-0 bg-gradient-to-b from-transparent to-white" />
                    </div>
                  </div>
                  <div className="px-6 pb-5">
                    <a
                      href="/samples/Furbabies_Sample_Meal_Plan.pdf"
                      download="Furbabies_Sample_Meal_Plan.pdf"
                      className="flex items-center justify-center gap-2 w-full bg-[#bda697] hover:bg-[#967d6c] transition-colors text-white font-semibold text-sm poppins-text py-3 rounded-xl"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="w-4 h-4"
                        fill="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6zm-1 7V3.5L18.5 9H13zM8 17v-2h8v2H8zm0-4v-2h8v2H8z" />
                      </svg>
                      Download Sample Nutrition Report
                    </a>
                  </div>
                </div>
              </div>

              <p className="text-xs poppins-text text-gray-400 text-center px-2">
                Free to download · No sign-up required · For educational
                purposes only
              </p>
            </motion.div>
          </div>
        </div>
      </section>

      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
            {/* Left — heading + paws */}
            <div className="relative flex flex-col justify-center">
              {/* Opening quote mark */}
              <div className="text-9xl font-serif text-[#967D6C]">&#8221;</div>

              <motion.h2
                className="lg:text-[60px] lg:leading-[70px] text-5xl font-bold text-gray-900"
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5 }}
              >
                Families of
                <br />
                Furbabies
              </motion.h2>

              {/* Dot indicators */}
              <div className="flex gap-2 mt-10">
                {testimonials.map((_, i) => (
                  <button
                    key={i}
                    onClick={() => setIndex([i, i > index ? 1 : -1])}
                    className={`h-2 rounded-full transition-all duration-300 ${
                      i === index
                        ? "w-8 bg-[#967d6c]"
                        : "w-2 bg-[#bda697] opacity-50"
                    }`}
                  />
                ))}
              </div>

              {/* Arrow controls */}
              <div className="flex gap-3 mt-6">
                <button
                  onClick={() => {
                    setPaused(true);
                    paginate(-1);
                  }}
                  className="w-10 h-10 rounded-full border border-[#bda697] text-[#967d6c] flex items-center justify-center hover:bg-[#967d6c] hover:text-white transition-all duration-200"
                >
                  &#8592;
                </button>
                <button
                  onClick={() => {
                    setPaused(true);
                    paginate(1);
                  }}
                  className="w-10 h-10 rounded-full border border-[#bda697] text-[#967d6c] flex items-center justify-center hover:bg-[#967d6c] hover:text-white transition-all duration-200"
                >
                  &#8594;
                </button>
              </div>

              {/* Floating paw accents */}
              <div className="hidden md:block absolute top-8 right-16 text-4xl text-[#bda697] opacity-40 select-none pointer-events-none animate-paw-right-left">
                <i className="fa fa-paw" />
              </div>
            </div>

            {/* Right — carousel card */}
            <div
              className="relative overflow-hidden"
              onMouseEnter={() => setPaused(true)}
              onMouseLeave={() => setPaused(false)}
            >
              <AnimatePresence mode="wait" custom={direction}>
                <motion.div
                  key={index}
                  custom={direction}
                  variants={variants}
                  initial="enter"
                  animate="center"
                  exit="exit"
                  transition={{ duration: 0.4, ease: "easeInOut" }}
                  className="bg-gray-50 rounded-2xl p-8 md:p-10"
                >
                  {/* Text + image row */}
                  <div className="flex items-start gap-6">
                    {/* Review text */}
                    <p className="flex-1 text-gray-700 text-base md:text-lg leading-8">
                      {current.text}
                    </p>

                    {/* Circular photo */}
                    <div className="shrink-0">
                      <img
                        src={current.image}
                        alt={current.name}
                        className="w-20 h-20 md:w-24 md:h-24 rounded-full object-cover ring-4 ring-white shadow-md"
                        loading="lazy"
                      />
                    </div>
                  </div>

                  {/* Name */}
                  <p className="mt-6 font-bold text-gray-900 text-base md:text-lg">
                    {current.name}
                  </p>
                </motion.div>
              </AnimatePresence>
            </div>
          </div>
        </div>
      </section>

      <section className="bg-white mt-4">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div className="relative flex flex-col items-center md:items-start justify-center text-center md:text-left">
              <motion.h2
                className="lg:text-[60px] lg:leading-[70px] text-5xl font-bold text-gray-900"
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5 }}
              >
                Don’t Delay. Try out Furbabies.AI Today!
              </motion.h2>
              <div className="hidden xl:block absolute top-8 sm:top-16 right-4 sm:right-8 text-3xl sm:text-4xl text-[#bda697] animate-paw-right-left">
                <i className="fa fa-paw"></i>
              </div>
              <div className="hidden xl:block absolute bottom-4 sm:bottom-8 left-4 sm:left-8 text-3xl sm:text-4xl text-[#bda697] animate-paw-left-right">
                <i className="fa fa-paw"></i>
              </div>
              <motion.button
                variants={buttonVariants}
                whileHover="hover"
                className="mt-6  text-xl px-12 py-4 lg:text-[20px] lg:leading-[26px] bg-[#967d6c] text-white font-bold rounded-full"
              >
                <Link to="/signup" className="text-white">
                  Sign Up for Free
                </Link>
              </motion.button>
            </div>
            <div className="flex justify-center md:justify-start">
              <motion.div
                className="w-full max-w-sm sm:max-w-md md:max-w-xl mb-0 md:mb-0"
                initial={{ opacity: 0, x: -50 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 1 }}
              >
                <img
                  src={doghero2}
                  alt="Dog"
                  className="rounded-xl w-full"
                  loading="lazy"
                />
              </motion.div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </section>
  );
};

export default Hero;
